import {
  Button,
  PageHeader,
  Space,
  Table,
  Modal,
  Col,
  Typography,
  Row,
  Form,
  Input,
  Select,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  TeamOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { useApiContext } from "../../hooks/useApiContext";
import apis from "../../services/apis";
import moment from "moment";

export default function InvoiceList() {
  const navigate = useNavigate();
  const { Column } = Table;
  const {
    invoicedispatch,
    invoices,
    user,
    projects,
    projectdispatch,
    businessdispatch,
    businesses,
  } = useApiContext();
  const [showDelete, setShowDelete] = useState(false);
  const [getId, setGetId] = useState();
  const [invoicesData, setInvoicesDate] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedProject, setSelectedProject] = useState();
  const [selectedBusiness, setSelectedBusiness] = useState();
  useEffect(() => {
    if (projects.length < 1) {
      apis.Projects.list(projectdispatch);
    }
    if (businesses.length < 1) {
      apis.Businesses.list(businessdispatch);
    }
    if (invoices.length < 1) apis.Invoices.list(invoicedispatch);
    setInvoicesDate(invoices.sort((a,b)=>new Date(b.invoiceDate).setHours(0, 0, 0, 0) - new Date(a.invoiceDate).setHours(0, 0, 0, 0)));
  }, [invoices.length < 1]);

  const confirmDelete = (id) => {
    setShowDelete(true);
    setGetId(id);
  };

  const getProjectData = (value) => {
    if (value === null) setInvoicesDate(invoices);
    if (!selectedBusiness) {
      var getData = invoices.filter((x) => x.projectId == value);
      setInvoicesDate(getData);
      
    } else {
      if (value === null) setInvoicesDate(invoices);
      var getData = invoices.filter((x) => x.businessId == selectedBusiness && x.projectId == value);
      setInvoicesDate(getData);

     
    }
    
    setInvoicesDate(getData);
    setSelectedProject(value)
    console.log("Project Data :: ", getData)
  };
  const getBusinessData = (value) => {
    // const data = businesses.filter((x) => x.id == value);
    setSelectedBusiness(value)
    // setGetBusinees(data);
    console.log("selectedProject :: ", selectedProject)
    if (!selectedProject) {
      var getData = invoices.filter((x) => x.businessId == value);
      setInvoicesDate(getData);
      
    } else {
      if (value === null) setInvoicesDate(invoices);
      var getData = invoices.filter((x) => x.businessId == value && x.projectId == selectedProject);
      setInvoicesDate(getData);

     
    }
  };
  // console.log("invoices :: ", invoices)
  const getInvoiceData = (value) => {
    console.log("search value", value.target.value);
    if (value.target.value === null) setInvoicesDate(invoices);
    var getData = invoices.filter((x) =>
      x.invoiceNumber.toLowerCase().includes(value.target.value.toLowerCase())
    );
    setInvoicesDate(getData);
  };

  const handleDelete = () => {
    setLoading(true);
    apis.Invoices.delete(invoicedispatch, getId).then((res) => {
      setShowDelete(false);
      setLoading(false);
      setGetId("");
    });
  };
  return (
    <>
      <PageHeader
        className="site-page-header"
        onBack={() => null}
        title="Invoice List"
        subTitle="Find the list of invoice list"
        extra={
          <Button
            type="primary"
            onClick={() => navigate("/addinvoice")}
            icon={<TeamOutlined />}
          >
            Add Invoice
          </Button>
        }
      />
      <Typography.Title level={4}>Filters</Typography.Title>
      <Row>

      <Col span={6} style={{ marginLeft: "20px" }}>
          <Form.Item label="Select Project" name="projectId">
            <Select
              placeholder="Select project"
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
              allowClear
              onChange={getProjectData}
            >
              {projects.map((item) => (
                <Select.Option value={item.id}>
                  {item.projectName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
  
        <Col span={8}>
          <Form.Item
            label="Select Business"
            name="businessId"
            rules={[{ required: true, message: "Please select business" }]}
          >
            <Select
          
            placeholder="Select Business"
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
              optionA.children
                .toLowerCase()
                .localeCompare(optionB.children.toLowerCase())
            }
            allowClear
            onChange={getBusinessData}
          >
            {businesses.map((item) => (
              
              <Select.Option value={item.id}>
                {item.businessName}
              </Select.Option>
            ))}
          </Select>
          </Form.Item>
        </Col>
        
      
        {/* <Col span={6} style={{ marginLeft: "10px" }}>
          <Form.Item label="Enter Employee Id">
            <Input
              placeholder="Enter employee id here"
              // onKeyUp={(e) => getsearchDataByEmpId(e)}
            />
          </Form.Item>
        </Col> */}
      </Row>
      <Col span={6}>
          <Form.Item label="Enter Invoice Number">
            <Input
              placeholder="Enter invoice number here"
              onKeyUp={(e) => getInvoiceData(e)}
            />
          </Form.Item>
        </Col>
      <Row>

      </Row>
      <Table dataSource={invoicesData}>
        <Column title="Invoice No" dataIndex="invoiceNumber" />
        <Column
          title="Invoice Date"
          dataIndex="invoiceDate"
          render={(text, record) => (
            <>{moment(record.invoiceDate).format("DD-MM-YYYY")}</>
          )}
        />
        <Column title="Invoice Amount" dataIndex="invoiceAmount" />
        <Column title="Invoice VAT Amount" dataIndex="vatAmount" />
        <Column
          render={(text, record) => (
            <Space>
              {(user.role == "admin" || localStorage.getItem("userRole") === "admin") && (<Link to={`/editinvoice/${record.id}`}>Edit</Link>)}
              {(user.role == "HR" || localStorage.getItem("userRole") === "HR") && (<Link to={`/editinvoice/${record.id}`}>Edit</Link>)}
                          
              <Link to={`/invoicedetails/${record.id}`}>Details</Link>

              {(user.role == "admin" || localStorage.getItem("userRole") === "admin") && 
        (<Button type="link" icon={<DeleteOutlined />}danger onClick={() => confirmDelete(record.id)}size="small">Delete</Button>)}
            </Space>
          )}
        />
      </Table>

      <Modal
        title="Confirmation"
        visible={showDelete}
        onOk={handleDelete}
        okText="Yes"
        okButtonProps={{ loading: loading }}
        onCancel={() => setShowDelete(false)}
        cancelButtonProps={{ disabled: true }}
      >
        <p>
          <InfoCircleOutlined twoToneColor="#eb2f96" /> Are you sure you want to
          delete this invoice
        </p>
      </Modal>
    </>
  );
}
